import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import withSuspense from '../../../components/HOC/SuspenseHOC'
import { RootState } from '../../../store/rootState'
import { IMenuItem } from '../../../types/menuItems'
import { IUserDetail } from '../../../types/user'
import * as MainActions from '../../main/actions/sidebarActions'
import * as NotificationActions from '../actions/notificationActions'
import NotificationsSidebar from '../components/NotificationsSidebar'
import { INotificationData } from '../types/notification'

interface StateProps {
  user: IUserDetail | null
  notifications: INotificationData[]
  activeMenuItem: IMenuItem
}

interface DispatchProps {
  updateNotification: (employee_id: number, notification_ids: number[]) => Promise<number[]>
  deleteNotification: (notification: INotificationData) => void
  setActiveMenuItem: (item: string, path: string) => void
  getNotifications: () => void
}

type Props = StateProps & DispatchProps

const NotificationsSidebarContainer = (props: Props): JSX.Element => {
  const {
    updateNotification,
    deleteNotification,
    setActiveMenuItem,
    user,
    notifications,
    activeMenuItem,
    getNotifications
  } = props

  useEffect(() => {
    if (activeMenuItem.name === 'notification' && activeMenuItem.path !== '/before-close-notification') {
      getNotifications()
    }
  }, [activeMenuItem])

  return (
    <NotificationsSidebar
      notifications={notifications}
      activeMenuItem={activeMenuItem}
      user={user}
      updateNotification={updateNotification}
      deleteNotification={deleteNotification}
      setActiveMenuItem={setActiveMenuItem}
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    user: state.authState.user,
    notifications: state.notificationState.notifications,
    activeMenuItem: state.mainState.activeMenuItem,
  }
}

const mapDispatchToProps = (dispatch: NotificationActions.NotificationsThunkDispatchType & MainActions.MainThunkDispatchType): DispatchProps => {
  return {
    updateNotification: (employee_id, notification_ids) => dispatch(NotificationActions.updateNotification(employee_id, notification_ids)),
    deleteNotification: notification => dispatch(NotificationActions.deleteNotification(notification)),
    setActiveMenuItem: (item: string, path: string) => dispatch(MainActions.setActiveMenuItem(item, path)),
    getNotifications: () => dispatch(NotificationActions.getNotifications()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withSuspense(NotificationsSidebarContainer))
